/* eslint-disable react/require-default-props */
/* eslint-disable import/no-unresolved */
import React from 'react';
import { Options } from 'react-lottie';
import checkedAnimation from 'assets/animations/checked_done.json';
import { Container, LottieWrapper } from './styles';

const animationLoopOptions = {
  loop: false,
  goAndStop: true,
  goAndPlay: false,
  isPaused: false,
  autoplay: false,
  isStopped: true,
  animationData: checkedAnimation,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
};

const useCallback = (callback: any, values: any) => {
  const self = React.useRef({
    values,
    handler: (...args: any) => {
      return callback(...args, self.current.values);
    },
  });
  self.current.values = values;
  return self.current.handler;
};

interface SelectButtonProps {
  id: number;
  toggleSelected?: (id: number, updateAll?: boolean) => void | null;
  toggleBulletin?: () => void | null;
  text: string;
  isChecked: boolean;
}

const SelectButton = (props: SelectButtonProps) => {
  const { isChecked, id, toggleSelected = null, text, toggleBulletin = null } = props;
  const [animationOptions, setAnimationOptions] = React.useState<Object>(animationLoopOptions);
  const [animationSwap, setAnimationSwap] = React.useState<boolean | null>(true);

  const handleLoopComplete = useCallback(
    (event: any, [...animationSwap]) => {
      if (animationSwap) {
        setAnimationOptions(animationOptions);
        setAnimationSwap(false);
      }
    },
    [animationSwap],
  );

  return (
    <Container
      onClick={() => {
        if (toggleSelected) {
          if (id === 0) toggleSelected(id, true);
          if (id !== 0) toggleSelected(id);
        } else if (toggleBulletin) {
          toggleBulletin();
        }
      }}
      className="bidding-item-header-button d-inline-flex hover-pointer"
    >
      <span className="tour-remove-favorites-select-all">
        <LottieWrapper
          style={{ width: '63px' }}
          isStopped={!isChecked}
          options={animationOptions as Options}
          eventListeners={[
            {
              eventName: 'complete',
              callback: handleLoopComplete,
            },
          ]}
        />
      </span>
      <span style={{ margin: 'auto 20px auto -15px' }}>{text}</span>
    </Container>
  );
};

export default SelectButton;
